export const stoli_podkatnie = {
    stol__psm__500x500: {
        name: "Стол подкатной (ПСМ), мм",
        title: "Стол подкатной (ПСМ)",
        price: 0,
        active: false,
        type: "500x500",
        width: 500,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__psm__700x500: {
        name: "Стол подкатной (ПСМ), мм",
        title: "Стол подкатной (ПСМ)",
        price: 0,
        active: false,
        type: "700x500",
        width: 700,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__psm__1000x700: {
        name: "Стол подкатной (ПСМ), мм",
        title: "Стол подкатной (ПСМ)",
        price: 0,
        active: false,
        type: "1000x700",
        width: 1000,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__psm__1200x700: {
        name: "Стол подкатной (ПСМ), мм",
        title: "Стол подкатной (ПСМ)",
        price: 0,
        active: false,
        type: "1200x700",
        width: 1200,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__psm__1500x700: {
        name: "Стол подкатной (ПСМ), мм",
        title: "Стол подкатной (ПСМ)",
        price: 0,
        active: false,
        type: "1500x700",
        width: 1500,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__psm__1800x700: {
        name: "Стол подкатной (ПСМ), мм",
        title: "Стол подкатной (ПСМ)",
        price: 0,
        active: false,
        type: "1800x700",
        width: 1800,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__ps_kp__500x500: {
        name: "Стол подкатной (ПС-КП), мм",
        title: "Стол подкатной (ПС-КП)",
        price: 0,
        active: false,
        type: "500x500",
        width: 500,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__ps_kp__700x500: {
        name: "Стол подкатной (ПС-КП), мм",
        title: "Стол подкатной (ПС-КП)",
        price: 0,
        active: false,
        type: "700x500",
        width: 700,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__ps_kp__1000x700: {
        name: "Стол подкатной (ПС-КП), мм",
        title: "Стол подкатной (ПС-КП)",
        price: 0,
        active: false,
        type: "1000x700",
        width: 1000,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__ps_kp__1200x700: {
        name: "Стол подкатной (ПС-КП), мм",
        title: "Стол подкатной (ПС-КП)",
        price: 0,
        active: false,
        type: "1200x700",
        width: 1200,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__psp_kp__500x700: {
        name: "Стол подкатной (ПСП-КП), мм",
        title: "Стол подкатной (ПСП-КП)",
        price: 0,
        active: false,
        type: "500x700",
        width: 500,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__psp_kp__700x700: {
        name: "Стол подкатной (ПСП-КП), мм",
        title: "Стол подкатной (ПСП-КП)",
        price: 0,
        active: false,
        type: "700x700",
        width: 700,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__psp_kp__700x1000: {
        name: "Стол подкатной (ПСП-КП), мм",
        title: "Стол подкатной (ПСП-КП)",
        price: 0,
        active: false,
        type: "700x1000",
        width: 700,
        depth: 1000,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__psp__500x700: {
        name: "Стол подкатной (ПСП), мм",
        title: "Стол подкатной (ПСП)",
        price: 0,
        active: false,
        type: "500x700",
        width: 500,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__psp__700x700: {
        name: "Стол подкатной (ПСП), мм",
        title: "Стол подкатной (ПСП)",
        price: 0,
        active: false,
        type: "700x700",
        width: 700,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__psp__700x1000: {
        name: "Стол подкатной (ПСП), мм",
        title: "Стол подкатной (ПСП)",
        price: 0,
        active: false,
        type: "700x1000",
        width: 700,
        depth: 1000,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__pst__500x500: {
        name: "Стол подкатной (ПСТ), мм",
        title: "Стол подкатной (ПСТ)",
        price: 0,
        active: false,
        type: "500x500",
        width: 500,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__pst__500x700: {
        name: "Стол подкатной (ПСТ), мм",
        title: "Стол подкатной (ПСТ)",
        price: 0,
        active: false,
        type: "500x700",
        width: 500,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stol__pst__700x1000: {
        name: "Стол подкатной (ПСТ), мм",
        title: "Стол подкатной (ПСТ)",
        price: 0,
        active: false,
        type: "700x1000",
        width: 700,
        depth: 1000,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};

export const zink_stoli_podkatnie = {
    zink__psm__500x500: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 500x500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__psm__700x500: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 700x500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__psm__1000x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1000x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__psm__1200x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1200x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__psm__1500x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1500x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__psm__1800x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1800x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__ps_kp__500x500: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 500x500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__ps_kp__700x500: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 700x500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__ps_kp__1000x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1000x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__ps_kp__1200x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1200x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__psp_kp__500x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 500x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__psp_kp__700x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 700x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__psp_kp__700x1000: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 700x1000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__psp__500x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 500x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__psp__700x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 700x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__psp__700x1000: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 700x1000",
        piece: 0,
        price_esd: 0,
        position: null,
    },

    zink__pst__500x500: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 500x500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__pst__500x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 500x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__pst__700x1000: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 700x1000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};

export const ruchkaSyomnaya = {
    ruchka__psm__500: {
        name: "Ручка съёмная, мм",
        price: 0,
        active: false,
        type: "500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    ruchka__psm__700: {
        name: "Ручка съёмная, мм",
        price: 0,
        active: false,
        type: "700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    ruchka__psp__500: {
        name: "Ручка съёмная, мм",
        price: 0,
        active: false,
        type: "500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    ruchka__psp__700: {
        name: "Ручка съёмная, мм",
        price: 0,
        active: false,
        type: "700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    ruchka__pst__500: {
        name: "Ручка съёмная, мм",
        price: 0,
        active: false,
        type: "500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    ruchka__pst__700: {
        name: "Ручка съёмная, мм",
        price: 0,
        active: false,
        type: "700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
